import { IRetirePetInput, IRetirePetResponse } from "./retire-pet.interface";

import { RETIRE_PET } from "./retire-pet.mutation";
import { toastMessageActions } from "../../state/request";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useMutation } from "@apollo/client";

export const useRetirePet = () => {
  const dispatch = useDispatch();
  const [retirePet, { data, loading }] = useMutation<{ retirePet: IRetirePetResponse }>(RETIRE_PET, {
    update(cache) {
      cache.evict({ fieldName: "dashboard" });
      cache.evict({ fieldName: "getPets" });
      cache.gc();
    },
  });

  const updateRetirePet = (retirePetInput: IRetirePetInput) => {
    retirePet({
      variables: { retirePetInput },
    });
  };

  useEffect(() => {
    dispatch(toastMessageActions.setGlobalLoading(loading));
  }, [loading]);

  return {
    petDeleted: data?.retirePet,
    updateRetirePet,
    loading,
  };
};
